module.exports = __webpack_public_path__ + "img/industry.49856ce4.svg";